import { useState } from "react";

import OnScreenKeyboard from "components/Tools/OnScreenKeyboard";
import Dialog from "componentsv2/modal/Dialog";
import proxy from "api/proxy";

function AgentModal({ openModal, onConfirm, onClose, agents }) {
  const [msg, setMsg] = useState("");

  async function handleCode(code) {
    const { data } = await proxy.search(
      "commission.agent",
      [["code", "=", code]],
      ["id", "code", "rec_name", "party", "user"],
    );
    const agent = data?.[0];
    if (!agent) {
      setMsg("Código inválido");
    } else {
      setMsg("");
      onConfirm(agent);
      openModal.value = false;
    }
  }
  return (
    <Dialog
      openModal={openModal}
      buttons={[]}
      handleClose={onClose}
      size={"w-5/6 sm:w-3/6 lg:w-1/3 h-4/6 lg:h-5/6"}
    >
      {msg && <span className="text-2xl text-red-400 px-2 md:px-6">{msg}</span>}
      <OnScreenKeyboard
        onClick={handleCode}
        onCancel={onClose}
        openModal={openModal}
      />
    </Dialog>
  );
}

export default AgentModal;
